const SAVOY_NET_URL_PREFIX_REGEX = /^https?:\/\/savoynet\.com\.br\/?/i

export function normalizeSavoyNetItem (value) {
  if (value === null || value === undefined) {
    return ''
  }

  return String(value)
    .trim()
    .replace(SAVOY_NET_URL_PREFIX_REGEX, '')
    .trim()
}

export function splitSavoyNetValues (value) {
  if (value === null || value === undefined) {
    return []
  }

  return String(value).split(/[\n,;]+/g)
}

export function normalizeSavoyNetList (value) {
  const source = Array.isArray(value) ? value : splitSavoyNetValues(value)
  const normalized = []
  const seen = {}

  source.forEach((item) => {
    const normalizedItem = normalizeSavoyNetItem(item)

    if (!normalizedItem || seen[normalizedItem]) {
      return
    }

    seen[normalizedItem] = true
    normalized.push(normalizedItem)
  })

  return normalized
}

export function parseSavoyNetFromApi (value) {
  if (Array.isArray(value)) {
    return normalizeSavoyNetList(value)
  }

  const normalized = normalizeSavoyNetItem(value)
  return normalized ? [normalized] : []
}

export function buildSavoyNetUrl (numero) {
  const normalized = normalizeSavoyNetItem(numero)
  return normalized ? `https://www.savoynet.com.br/Dados_contrato.aspx?contrato=${normalized}` : ''
}



// WEBPACK FOOTER //
// ./src/utils/savoynet.js